import { all } from 'async-saga';
import { routerActions } from 'connected-react-router';
import { actions } from '..';
import * as api from '../../api';
import { saveApplicationSettings } from '../../api/options-control';
import { EntityType } from '../../model';
import { selectApplicationSetting, selectAwayFromDeskTimeoutSeconds, selectFavExtensionFolderId, selectMyAccess, selectMyself, selectRegions } from '../reducers/config';
import { selectDirectoryView } from '../reducers/localSettings';
import { selectExtension, selectRegionExtenions } from '../reducers/queueAgents';
import { takeEvery, waitForState } from '../tools/async-saga-types';

const fetchExtensionsRequeust = takeEvery(actions.fetchExtensionsRequeust, async (ctx, { regionId }) => {
  const store = ctx.getState()
  const mySelf = selectMyself(store)
  const folderId = selectFavExtensionFolderId(store)
  if (mySelf && folderId) {
    let page = 0
    if (folderId === regionId) {
      while (true) {
        const extensions = await api.getExtensionFavs(mySelf, folderId, page)
        ctx.dispatch(actions.fetchExtensionsResponse(regionId, extensions.rows))
        if (extensions.total > page + 1) {
          page += 1
        } else {

          break;
        }
      }
    } else {
      while (true) {
        const extensions = await api.getExtensions(mySelf, regionId, page)
        ctx.dispatch(actions.fetchExtensionsResponse(regionId, extensions.rows))
        if (extensions.total > page + 1) {
          page += 1
        } else {
          break;
        }
      }
    }
  }
})

const fetchExtensionsByIds = takeEvery(actions.fetchExtensionsByIds, async (ctx, { ids }) => {
  const store = ctx.getState()
  const mySelf = selectMyself(store)
  if (mySelf) {
    let page = 0
    while (true) {
      const extensions = await api.getExtensionsByIds(mySelf, ids, page)

      ctx.dispatch(actions.fetchExtensionsByIdsResponse(extensions.rows))
      if (extensions.total > page + 1) {
        page += 1
      } else {
        break;
      }
    }
  }
})

const favouriteExtension = takeEvery(actions.favouriteExtension, async (ctx, { extension, add }) => {
  const parentId = await waitForState(ctx, selectFavExtensionFolderId)
  if (add) {
    await api.addFavouriteExtension(extension)
  } else {
    await api.removeFavouriteExtension(extension, parentId)
  }

  ctx.dispatch(actions.favouriteExtensionAction(extension, add, parentId))
})

const setSelectedExtension = takeEvery(actions.setSelectedExtension, async (ctx, { extension, edit }) => {
  const store = ctx.getState()
  const item = extension && selectExtension(store, extension)
  const view = selectDirectoryView(store)
  const regions = selectRegions(store)
  const folderId = selectFavExtensionFolderId(store)
  const access = selectMyAccess(store)
  //const userLevel = selectConfigProp(store, 'baseUserLevel')
  //userLevel >= UserLevel.Supervisor && userLevel <= UserLevel.IPFXTechnician && edit

  if (extension && item && regions && folderId) {
    if (window.location.pathname.indexOf('/directory') === -1 || view.entityType !== EntityType.Extension) {
      ctx.dispatch(routerActions.replace('/directory'))
      ctx.dispatch(actions.setDirectoryView({ regionId: item.regionId, entityType: EntityType.Extension }))
      //ctx.dispatch(actions.setSelectedContact(extension))
      ctx.dispatch(actions.setSelectedNumber(extension.id))
      ctx.dispatch(actions.updateSelectedExtension(extension, edit))
    } else {
      if (access.features.toolbarDirectory) {
        const extensions = selectRegionExtenions(store, view.regionId)
        //if not found then lets load the extension view to find it and reselect
        if (extensions && !extensions.find(x => x.id === extension.id && x.server === extension.server)) {
          ctx.dispatch(actions.setDirectoryView({ regionId: item.regionId, entityType: EntityType.Extension }))
          //ctx.dispatch(actions.setSelectedContact(extension))
          //ctx.dispatch(actions.setSelectedExtension(extension, edit))
        }
        ctx.dispatch(actions.setSelectedNumber(extension.id))
        ctx.dispatch(actions.updateSelectedExtension(extension, edit))
      }
    }

  }
})

const setShowShortcutsToolbar = takeEvery(actions.setShowShortcutsToolbar, async (ctx, setting) => {
  const state = selectApplicationSetting(ctx.getState(), 'ShowShortcutsToolbar')
  const myId = selectMyself(ctx.getState())
  if (myId && state) {
    //save to the server
    const s = await saveApplicationSettings(myId, { ...state, value: (setting ? '1' : '0') })
    //update cache
    ctx.dispatch(actions.updateApplicationSetting(s))
  }
})

const setAwayFromDesk = takeEvery(actions.setIdleSeconds, async (ctx, idleSeconds) => {
  const myId = selectMyself(ctx.getState())
  if (!myId) return

  const extension = selectExtension(ctx.getState(), myId)
  if (!extension) return

  const awayTimeoutSeconds = selectAwayFromDeskTimeoutSeconds(ctx.getState())
  if (awayTimeoutSeconds === -1) return
  const prevIdleSeconds = ctx.prevState.idleSeconds
  if (idleSeconds < prevIdleSeconds && extension.awayFromDesk) {
    ctx.dispatch(actions.setAwayFromDesk(false))
  } else if (idleSeconds >= awayTimeoutSeconds && !extension.awayFromDesk) {
    ctx.dispatch(actions.setAwayFromDesk(true))
  }
})

const setAwayFromDeskTimeout = takeEvery(actions.setAwayFromDeskTimeout, async (ctx, awayFromDeskTimeoutSeconds) => {
  const state = selectApplicationSetting(ctx.getState(), 'AwayFromDeskTimeoutSeconds')
  const myId = selectMyself(ctx.getState())
  if (myId && state) {
    //save to the server
    const s = await saveApplicationSettings(myId, { ...state, value: awayFromDeskTimeoutSeconds.toString() })
    //update cache
    ctx.dispatch(actions.updateApplicationSetting(s))
  }
})

export default all(
  fetchExtensionsRequeust,
  favouriteExtension,
  fetchExtensionsByIds,
  setSelectedExtension,
  setShowShortcutsToolbar,
  setAwayFromDesk,
  setAwayFromDeskTimeout,
)
